import React from "react";
import { useT } from "@/lib/LanguageContext";
import { tenantHref } from "@/lib/tenantPath";
// Relative on purpose: pure modules, resolvable under Jest without a shim.
import { CATALOGUE_PATH } from "../../pathways/learnerModel";
import { PATHWAYS_LEARNER as IDS } from "../../constants/testIds/pathwaysLearner";

/**
 * "This pathway does not exist, or you have not joined it." One answer for every case the
 * contract refuses to tell apart (absent, draft, archived for a visitor, not joined:
 * contract §5.4, one 404).
 *
 * `onSignIn`, when given, adds a sign-in button: an ARCHIVED pathway is hidden from the
 * public but stays readable by its learners, so a signed-out visitor holding the link of a
 * pathway they followed must be able to prove it is theirs.
 *
 * @param {{ onSignIn?: () => void }} props
 */
export default function PathwayNotFound({ onSignIn }) {
  const t = useT("public");
  return (
    <div data-testid={IDS.notFound} className="mx-auto max-w-xl rounded-3xl border border-eh-border-soft bg-eh-cream px-6 py-12 text-center">
      <h1 className="font-display text-3xl text-eh-ink">{t("pathways.notFound.title")}</h1>
      <p className="mt-3 text-eh-muted">{t("pathways.notFound.body")}</p>
      {onSignIn && (
        <button
          type="button"
          onClick={onSignIn}
          data-testid={IDS.notFoundSignIn}
          className="mt-6 inline-flex h-11 items-center rounded-full bg-eh-ink px-6 text-sm font-medium text-eh-cream"
        >
          {t("pathways.notFound.signIn")}
        </button>
      )}
      <div className="mt-6 flex flex-wrap justify-center gap-4 text-sm font-medium">
        <a href={tenantHref("/compte")} className="text-eh-ink underline">{t("pathways.notFound.account")}</a>
        <a href={tenantHref(CATALOGUE_PATH)} className="text-eh-ink underline">{t("pathways.notFound.browse")}</a>
      </div>
    </div>
  );
}
